var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35641 13.2562L15.772 5.84063C15.947 5.66563 16.1512 5.57812 16.3845 5.57812C16.6179 5.57812 16.822 5.66563 16.997 5.84063C17.172 6.01563 17.2595 6.22358 17.2595 6.4645C17.2595 6.70542 17.172 6.91308 16.997 7.0875L8.96891 15.1375C8.79391 15.3125 8.58974 15.4 8.35641 15.4C8.12307 15.4 7.91891 15.3125 7.74391 15.1375L3.98141 11.375C3.80641 11.2 3.72241 10.9923 3.72941 10.752C3.73641 10.5117 3.8277 10.3037 4.00328 10.1281C4.17887 9.95254 4.38682 9.86504 4.62716 9.86562C4.86749 9.86621 5.07516 9.95371 5.25016 10.1281L8.35641 13.2562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.212680f617816b4eb046e957e76e4a44.svg";
export { ForwardRef as ReactComponent };